export default {
	list: 'Documents',
	grid: {
		gridId: 'DocumentManagerGrid',
		checkbox: true
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable:false
		},
		Actions: {
			class: 'value',
			editable: false,
			title: 'Actions',
			width: 120,
			type: 'dropdownactions',
			key: "Id",
			menu: [
				{
					"Edit": "Edit",
					"Cancel": "Cancel",
					"Delete": "Delete",
					"Save": "Save",
				//	"OpenLive": "Open Live",
					"Download": "Download"
				}
			],
			hidden: false,
			readOnly: true
		},
		FileName: {
			class: 'lookup',
			dataName: 'File/Name',
			type: 'string',
			title: 'File Name',
			width: 250,
			hidden: false
		},
		FileServerRelativeUrl: {
			class: 'lookup',
			dataName: 'File/ServerRelativeUrl',
			type: 'string',
			title: 'ServerRelativeUrl',
			width: 150,
			hidden: true,
			readOnly: true,
			editable:false
		},
		ProgramId: {
			class: 'lookup',
			dataName: 'Program/Id',
			type: 'number',
			title: 'ProgramId',
			width: 100,
			hidden: true,
			readOnly:true,
			editable:false
		},
		ProgramTitle: {
			class: 'lookup',
			dataName: 'Program/Title',
			type: 'string',
			//dropdown: true,
			source:'ProgramTypeOptions',
			title: 'Program',
			width: 150,
			hidden: true,
			readOnly: true,
			editable:false
		},
		PartnerId: {
			class: 'lookup',
			dataName: 'Partner/Id',
			type: 'number',
			title: 'PartnerId',
			width: 100,
			hidden: true,
			readOnly:true,
			editable:false
		},
		PartnerTitle: {
			class: 'lookup',
			dataName: 'Partner/FullName',
			type: 'string',
			//dropdown: true,
			source:'PartnerTypeOptions',
			title: 'Partner',
			width: 150,
			hidden: true,
			readOnly: true,
			editable:false
		},
		DocumentType: {
			class: 'choice',
			dataName: 'DocumentType',
			type: 'dropdown',
			title: 'Document Type',
			dropdown: true,
			width: 200,
			hidden: false,
			readOnly: false
		},
		BusinessEvent: {
			class: 'value',
			dataName: 'BusinessEvent',
			type: 'string',
			title: 'Document Level',
			width: 170,
			hidden: true,
			editable:false,
			readOnly: true
		},
		TransactionID:{
			class: 'value',
			dataName: 'TransactionID',
			type: 'number',
			title: 'Transaction ID',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: true
		},
		BatchGUID:{
			class: 'value',
			dataName: 'BatchGUID',
			type: 'number',
			title: 'Batch Id',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: true
		},
		ProgramIdList:{
			class: 'value',
			dataName: 'ProgramIdList',
			type: 'string',
			title: 'ProgramIdList',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: false
		},
		PartnerIdList:{
			class: 'value',
			dataName: 'PartnerIdList',
			type: 'string',
			title: 'PartnerIdList',
			width: 100,
			hidden: true,
			editable:false,
			readOnly: false
		},
	}
}